<template>
  <div>
    <div>
      <Subscription />
    </div>
    <div
      :class="[
        'footer footer--color',
        isMobileLayout ? 'footer--mobile' : '',
        isRestaurant && 'is-restaurant',
        isRestaurantDetail && 'is-restaurant',
      ]"
    >
      <MainLayout class="container">
        <mq-layout :mq="['xs', 'sm', 'md']" style="width: 90%; margin: auto">
          <el-row>
            <el-col :span="12" class="text-left pt-30">
              <el-image
                style="width: 167px"
                :src="images.logo.src"
                :fit="'contain'"
              />
              <div class="subtitle2 mt-8">
                <div
                  v-if="country === 'QC'"
                  style="height: 63px; line-height: 17.5px"
                >
                  <div>{{ addressMontrealLine1 }}</div>
                  <div>{{ addressMontrealLine2 }}</div>
                  <div>{{ addressMontrealLine3 }}</div>
                </div>
                <div v-else style="height: 63px; line-height: 17.5px">
                  <div>{{ addressTorontoLine1 }}</div>
                  <div>{{ addressTorontoLine2 }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="12" class="pl-26 pt-26">
              <div class="flex mt-15 ml-15">
                <a
                  href="https://www.youtube.com/channel/UCIEjAJMsHkVba-H1rOdBqIg"
                  target="blank"
                >
                  <el-image
                    class="mr-10"
                    style="height: 28px"
                    :src="images.youtubeIcon.src"
                    :fit="'contain'"
                  />
                </a>
                <a href="https://www.instagram.com/boires.ca/" target="blank">
                  <el-image
                    class="mr-10"
                    style="height: 28px"
                    :src="images.instagramIcon.src"
                    :fit="'contain'"
                  />
                </a>
                <a href="https://www.facebook.com/boires.ca/" target="blank">
                  <el-image
                    class="mr-10"
                    style="height: 28px"
                    :src="images.facebookIcon.src"
                    :fit="'contain'"
                  />
                </a>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col
              v-for="(menuGroup, i) in menuGroupsMobile"
              :key="i"
              :span="12"
              :class="[
                'mt-40 text-left',
                menuGroup.isBlank ? 'blank-menu' : '',
              ]"
              :style="{
                'padding-left':
                  i % 2 || i == menuGroupsMobile.length - 1 ? '30px' : '0',
                clear: i == 2 ? 'both' : '',
              }"
            >
              <h5 class="menu--header">
                {{ menuGroup.menuHeader }}
              </h5>
              <div v-for="(menuItem, j) in menuGroup.menuItems" :key="j">
                <div @click="openCollapse(menuItem)">
                  <FooterMenuItem
                    :path="menuItem.path"
                    :label="menuItem.label"
                  />
                </div>
                <template
                  v-if="menuItem.subMenuItems && menuItem.collapsed == false"
                >
                  <div
                    class="ml-20"
                    v-for="(subItem, k) in menuItem.subMenuItems"
                    :key="k"
                  >
                    <FooterMenuItem
                      :path="subItem.path"
                      :label="subItem.label"
                    />
                  </div>
                </template>
              </div>
            </el-col>
          </el-row>
          <el-divider class="mb-20" />
          <div class="subtitle2 content-license text-center">
            {{ year }} {{ allRightsReserved }}
          </div>
        </mq-layout>
        <mq-layout mq="lg+">
          <el-row class="pt-42">
            <el-col :span="6" class="text-left">
              <el-image
                style="width: 167px"
                :src="images.logo.src"
                :fit="'contain'"
              />
              <div class="subtitle2 mt-8">
                <div
                  v-if="country === 'QC'"
                  style="height: 63px; line-height: 17.5px"
                >
                  <div>{{ addressMontrealLine1 }}</div>
                  <div>{{ addressMontrealLine2 }}</div>
                  <div>{{ addressMontrealLine3 }}</div>
                </div>
                <div v-else style="height: 63px; line-height: 17.5px">
                  <div>{{ addressTorontoLine1 }}</div>
                  <div>{{ addressTorontoLine2 }}</div>
                </div>
                <div class="flex mt-0" v-if="country === 'QC'">
                  <a
                    :href="$i18n.t('common.footer.socialLink.youtube')"
                    target="blank"
                  >
                    <el-image
                      class="mr-20"
                      style="height: 28px"
                      :src="images.youtubeIcon.src"
                      :fit="'contain'"
                    />
                  </a>
                  <a
                    :href="$i18n.t('common.footer.socialLink.instagram')"
                    target="blank"
                  >
                    <el-image
                      class="mr-20"
                      style="height: 28px"
                      :src="images.instagramIcon.src"
                      :fit="'contain'"
                    />
                  </a>
                  <a
                    :href="$i18n.t('common.footer.socialLink.facebook')"
                    target="blank"
                  >
                    <el-image
                      class="mr-20"
                      style="height: 28px"
                      :src="images.facebookIcon.src"
                      :fit="'contain'"
                    />
                  </a>
                </div>
                <div class="flex mt-0" v-else>
                  <a
                    :href="$i18n.t('common.footer.socialLink.youtube')"
                    target="blank"
                  >
                    <el-image
                      class="mr-20"
                      style="height: 28px"
                      :src="images.youtubeIcon.src"
                      :fit="'contain'"
                    />
                  </a>
                  <a
                    :href="'https://www.instagram.com/boires.on/'"
                    target="blank"
                  >
                    <el-image
                      class="mr-20"
                      style="height: 28px"
                      :src="images.instagramIcon.src"
                      :fit="'contain'"
                    />
                  </a>
                  <a
                    :href="'https://www.facebook.com/boires.on'"
                    target="blank"
                  >
                    <el-image
                      class="mr-20"
                      style="height: 28px"
                      :src="images.facebookIcon.src"
                      :fit="'contain'"
                    />
                  </a>
                </div>
              </div>
            </el-col>
            <el-col
              v-for="(menuGroup, i) in menuGroups"
              :key="i"
              :span="menuGroup.isBlank ? 0 : 3"
              :class="['mt-8 text-left', menuGroup.isBlank ? 'blank-menu' : '']"
            >
              <h5 class="menu--header">
                {{ menuGroup.menuHeader }}
              </h5>
              <template v-if="reRender == true">
                <div v-for="(menuItem, j) in menuGroup.menuItems" :key="j">
                  <div @click="openCollapse(menuItem)">
                    <FooterMenuItem
                      :path="menuItem.path"
                      :label="menuItem.label"
                    />
                  </div>
                  <template
                    v-if="menuItem.subMenuItems && menuItem.collapsed == false"
                  >
                    <div
                      class="ml-20"
                      v-for="(subItem, k) in menuItem.subMenuItems"
                      :key="k"
                    >
                      <FooterMenuItem
                        :path="subItem.path"
                        :label="subItem.label"
                      />
                    </div>
                  </template>
                </div>
              </template>
            </el-col>
          </el-row>
          <el-divider class="mt-56 mb-20" />
          <div class="subtitle2 content-license text-right">
            {{year}}  {{ allRightsReserved }}
          </div>
        </mq-layout>
      </MainLayout>
    </div>
    <el-dialog
      class="cookies"
      :visible.sync="addQCCookies"
      :header="false"
      width="460px"
      v-if="cookiesModalType == 'QC'"
      :before-close="handleModalClose"
    >
      <el-row>
        <el-col class="pl-10">
          <template v-if="!deniedAccess">
            <label class="title">{{ $t("home.cookiesModal.title") }}</label>
            <div class="description cookie-model">
              <p>{{ $t("home.cookiesModal.p1") }}</p>
              <p class="mb-20">{{ $t("home.cookiesModal.p2") }}</p>
              <p>{{ $t("home.cookiesModal.p3") }}</p>
              <p>{{ $t("home.cookiesModal.p4") }}</p>
            </div>
            <el-button type="primary" class="button" @click="acceptcookies()">
              {{ $t("home.cookiesModal.submit") }} </el-button
            ><br />
            <el-checkbox class="remember" v-model="cookieRemember">{{
              $t("home.cookiesModal.remember")
            }}</el-checkbox>
          </template>
          <template v-else>
            <label class="title">{{ $t("home.cookiesModal.title") }}</label>
            <div class="description cookie-model">
              <p>{{ $t("home.cookiesModal.denyMessage") }}</p>
            </div>
          </template>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      class="cookies"
      :visible.sync="addONCookies"
      :header="false"
      width="460px"
      :before-close="handleModalClose"
      v-else
    >
      <el-row>
        <el-col class="pl-10">
          <template v-if="!deniedAccess">
            <label class="title">{{ $t("home.cookiesModalOn.title") }}</label>
            <div class="description cookie-model">
              <p>{{ $t("home.cookiesModalOn.p1") }}</p>
              <p class="mb-20">{{ $t("home.cookiesModalOn.p2") }}</p>
              <p>{{ $t("home.cookiesModalOn.p3") }}</p>
              <p>{{ $t("home.cookiesModalOn.p4") }}</p>
            </div>
            <el-button type="primary" class="button" @click="acceptOncookies()">
              {{ $t("home.cookiesModalOn.submit") }} </el-button
            ><br />
            <el-checkbox class="remember" v-model="cookieRemember">{{
              $t("home.cookiesModalOn.remember")
            }}</el-checkbox>
          </template>
          <template v-else>
            <label class="title">{{ $t("home.cookiesModal.title") }}</label>
            <div class="description cookie-model">
              <p>{{ $t("home.cookiesModal.denyMessage") }}</p>
            </div>
          </template>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      class="cookies province-modal"
      :visible.sync="provinceModal"
      :header="false"
      width="460px"
    >
      <el-row>
        <el-col class="pl-10">
          <div class="description cookie-model">
            <p v-if="cookiesModalType == 'QC'">
              {{ $t("home.provinceModalQc") }}
            </p>
            <p v-else>{{ $t("home.provinceModalOn") }}</p>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { get, sortBy } from "@/utils/lodash";
import MainLayout from "@/components/layout/main-layout.vue";
import layoutUtils from "@/utils/layout-utils";

import imgLogoWhite from "@/assets/images/logo/logo-white.png";
import imgYoutubeIcon from "@/assets/images/footer/icons/footer-youtube.png";
import imgInstagramIcon from "@/assets/images/footer/icons/footer-instagram.png";
import imgFacebookIcon from "@/assets/images/footer/icons/footer-facebook.png";

import FooterMenuItem from "./footer-menu-item.vue";
import Subscription from "@/views/subscription/components/subscription.vue";

import Store from '@/store';


export default {
  components: {
    MainLayout,
    FooterMenuItem,
    Subscription,
  },
  data() {
    return {
      images: {
        logo: {
          src: imgLogoWhite,
        },
        youtubeIcon: {
          src: imgYoutubeIcon,
        },
        instagramIcon: {
          src: imgInstagramIcon,
        },
        facebookIcon: {
          src: imgFacebookIcon,
        },
      },
      addQCCookies: false,
      addONCookies: false,
      cookieRemember: false,
      reRender: true,
      cookiesModalType: localStorage.getItem('actualCountryCode') || 'QC',
      provinceModal: false,
      deniedAccess: false,
      year: new Date().getFullYear(),
    };
  },
  mounted() {
    const getCookiesValue = localStorage.getItem('rememberMeCookies') || false;
    if (getCookiesValue) {
      const getTime = parseInt(localStorage.getItem('cookieExpireTime'));
      const currentTime = new Date().getTime();
      if(currentTime > getTime) {
        localStorage.removeItem('rememberMeCookies');
        localStorage.removeItem('cookieExpireTime');
      }
    }
    setTimeout(() => {
      this.checkCookiesAndRoute();
    }, 3000);
    if(this.isLoggedIn == false) {
      this.$root.$on("chancountryCode", (code) => {
          if (this.cookiesModalType !== code){
            this.cookiesModalType = localStorage.getItem("countryCode");
            this.provinceModal = true;
          }
  
            setTimeout(() => {
              this.provinceModal = false;
            }, 3000);
            setTimeout(() => {
              this.cookiesModalType = code;
            }, 3000);
          });
        }
  },
  computed: {
    ...mapState("configuration", ["actionBar"]),
    ...mapGetters("user", ["isLoggedIn"]),

    country() {
      return get(this.actionBar, "country");
    },
    addressMontrealLine1() {
      return this.$i18n.t("common.footer.address.montreal.line1");
    },
    addressMontrealLine2() {
      return this.$i18n.t("common.footer.address.montreal.line2");
    },
    addressMontrealLine3() {
      return this.$i18n.t("common.footer.address.montreal.line3");
    },
    addressTorontoLine1() {
      return this.$i18n.t("common.footer.address.toronto.line1");
    },
    addressTorontoLine2() {
      return this.$i18n.t("common.footer.address.toronto.line2");
    },
    allRightsReserved() {
      return this.$i18n.t("common.footer.allRightsReserved");
    },
    isRestaurant() {
      return this.$route && this.$route.fullPath.indexOf("inventory=") > -1
        ? true
        : false;
    },
    isRestaurantDetail() {
      return this.$route && this.$route.fullPath.indexOf("productType=") > -1
        ? true
        : false;
    },
    menuGroups() {
      return [
        {
          mobileIndex: 1,
          menuHeader: this.$i18n.t("common.footer.menus.menuAbout.header"),
          menuItems: [
            {
              path: "/about-us",
              label: this.$i18n.t("common.footer.menus.menuAbout.company"),
            },
            {
              path: "",
              label: this.$i18n.t("common.footer.menus.menuDiscovery.contact"),
            },
            {
              path: "/pricing-policy",
              label: this.$i18n.t('common.footer.menus.menuAbout.privacy')
            },
            {
              path: "/faq",
              label: this.$i18n.t("common.footer.menus.menuAbout.faq"),
            },
          ],
        },
        {
          isBlank: true,
        },
        {
          mobileIndex: 3,
          menuHeader: this.$i18n.t("common.footer.menus.menuAgency.header"),
          menuItems: [
            {
              path: "/products",
              label: this.$i18n.t("common.footer.menus.menuAgency.agence"),
            },
          ],
        },
        {
          isBlank: true,
        },
        {
          mobileIndex: 3,
          menuHeader: this.$i18n.t("common.footer.menus.menuRestaurant.header"),
          menuItems: [
            { 
              path: '/products?inventory=STORE_MTL',
              label: this.$i18n.t(
                "common.footer.menus.menuRestaurant.montreal"
              ),
            },
            {
              path: '/products?inventory=STORE_TORONTO',
              label: this.$i18n.t("common.footer.menus.menuRestaurant.toronto"),
            },
            {
              // path: (localStorage.getItem("countryCode") == 'ON' ) ? `products?type=MENU&inventory=STORE_TORONTO&sortByPrice=desc`: (localStorage.getItem("countryCode") == 'QC' ) ? `products?inventory=STORE_MTL&&type=MENU&sortByPrice=desc` : '',
              label: this.$i18n.t("common.footer.menus.menuRestaurant.menu"),
              path:
                localStorage.getItem("countryCode") == "ON"
                  ? {
                      name: "products",
                      query: {
                        page: 1,
                        req: true,
                        inventory: ["STORE_TORONTO"],
                        sortByPrice: ["desc"],
                      },
                      props: {
                        inventory: ["STORE_TORONTO"],
                        sortByPrice: ["desc"],
                      },
                    }
                  : localStorage.getItem("countryCode") == "QC"
                  ? {
                      name: "products",
                      query: {
                        page: 1,
                        req: true,
                        inventory: ["STORE_MTL"],
                        sortByPrice: "desc",
                      },
                      props: {
                        inventory: ["STORE_MTL"],
                        sortByPrice: ["desc"],
                      },
                    }
                  : {},
            },
          ],
        },
        {
          isBlank: true,
        },
        {
          mobileIndex: 4,
          menuHeader: this.$i18n.t("common.footer.menus.menuStore.header"),
          menuItems: [
            {
              path: "/products?type=WINES",
              label: this.$i18n.t("common.footer.menus.menuStore.boisson"),
            },
            {
              path: "/products?type=FOODS",
              label: this.$i18n.t("common.footer.menus.menuStore.epicerie"),
            },
            {
              path: "/products?type=GOODS",
              label: this.$i18n.t("common.footer.menus.menuStore.marchandise"),
            },
          ],
          col: 3,
        },
        {
          isBlank: true,
        },
        {
          mobileIndex: 2,
          menuHeader: this.$i18n.t("common.footer.menus.menuDiscovery.header"),
          menuItems: [
          {
              path: `/providers?type=${this.country}`,
              label: this.$i18n.t(
                "common.footer.menus.menuDiscovery.producers"
              ),
            },
            {
              path: localStorage.getItem("countryCode") == "ON"
                  ? {
                      name: "products",
                      query: {
                        page: 1,
                        req: true,
                        inventory: ["STORE_TORONTO"],
                        sortByPrice: ["desc"],
                      },
                      props: {
                        inventory: ["STORE_TORONTO"],
                        sortByPrice: ["desc"],
                      },
                    }
                  : localStorage.getItem("countryCode") == "QC"
                  ? {
                      name: "products",
                      query: {
                        page: 1,
                        req: true,
                        inventory: ["STORE_MTL"],
                        sortByPrice: "desc",
                      },
                      props: {
                        inventory: ["STORE_MTL"],
                        sortByPrice: ["desc"],
                      },
                    }
                  : {},
              label: this.$i18n.t("common.footer.menus.menuDiscovery.boutique")
            },
            {
              path: "/blogs",
              label: this.$i18n.t("common.footer.menus.menuDiscovery.blogs"),
            },
            {
              path: "/membres",
              label: this.$i18n.t(
                "common.footer.menus.menuDiscovery.becomeAMember"
              ),
            },
            {
              path: '',
              label: this.$i18n.t("common.footer.menus.menuDiscovery.member")
            }
          ],
        },
        {
          isBlank: true,
        },
        {
          mobileIndex: 5,
          menuHeader: this.$i18n.t("common.footer.menus.menuProducts.header"),
          menuItems: [
            {
              path: {
                name: "products",
                query: {
                  page: 1,
                  req: true,
                  type: ["VIN"],
                },
                props: {
                  setProductTypes: ["VIN"],
                },
              },
              label: this.$i18n.t("common.footer.menus.menuProductsNew.wines")
            },
            {
              path: {
                name: "products",
                query: {
                  page: 1,
                  req: true,
                  type: ["SPIRITUEUX"],
                },
                props: {
                  setProductTypes: ["SPIRITUEUX"],
                },
              },
              label: this.$i18n.t("common.footer.menus.menuProductsNew.spirits")
            },
            {
              path: {
                name: "products",
                query: {
                  page: 1,
                  req: true,
                  type: ["BOISSON"],
                },
                props: {
                  setProductTypes: ["BOISSON"],
                },
              },
              label: this.$i18n.t("common.footer.menus.menuProductsNew.alcoholFree")
            },
            {
              path: {
                name: "products",
                query: {
                  page: 1,
                  req: true,
                  type: ["BIERE", "CIDRE", "APERITIF"],
                },
                props: {
                  setProductTypes: ["BIERE", "CIDRE", "APERITIF"],
                },
              },
              label: this.$i18n.t("common.footer.menus.menuProductsNew.otherProducts")
            }
          ],
        },
      ];
    },
    menuGroupsMobile() {
      const arr = this.menuGroups.filter((m) => !m.isBlank);
      return sortBy(arr, (a) => a.mobileIndex);
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
  },
  methods: {
    ...mapActions("user", ["logout"]),
    acceptcookies() {
      localStorage.setItem("QcCookieSet", true);
      this.addQCCookies = false;
      this.deniedAccess = false;
    },
    acceptOncookies() {
      localStorage.setItem("OnCookieSet", true);
      this.addONCookies = false;
      this.deniedAccess = false;
    },
    openCollapse(data) {
      if (data.subMenuItems) {
        this.reRender = false;
        data.collapsed = !data.collapsed;
        this.$nextTick(() => {
          this.reRender = true;
        });
      }
      const userCountry = localStorage.getItem("countryCode");
      if (
      (userCountry === "QC" && data.path?.includes("STORE_TORONTO")) ||
      (userCountry === "ON" && data.path?.includes("STORE_MTL"))
    ) {
      this.handleLogout();
      return;
    }

    // If the menu item has a valid path, navigate
    if (data.path) {
      this.$router.push(data.path);
    }
    },
    handleModalClose() {
      this.deniedAccess = true;
        this.reRender = !this.reRender;
    },
    checkCookiesAndRoute() {
      const getCookiesValue = localStorage.getItem('rememberMeCookies') || false;
      const getCountryCode = localStorage.getItem('actualCountryCode');
      if(this.isLoggedIn == true) {
        if((getCountryCode == 'QC' && this.$route.path === '/on') || (getCountryCode == 'ON' && this.$route.path === '/qc')) {
          this.handleLogout();
          return;
        } 
      }
      if (getCookiesValue == false){
        if (this.$route.path === '/' || this.$route.path === '/qc') {
          this.addQCCookies = true;
          this.addONCookies = false
        } 
        if (this.$route.path === '/on') {
          setTimeout(() => {
            this.addONCookies = true
            this.addQCCookies = false;
          }, 2000);
        }
      }
      
    },
    handleLogout() {
      Store.dispatch('user/logout');
      Store.dispatch('shoppingCart/emptyShoppingCart');
      Store.dispatch('user/createTempUser');
      
      this.logout();
      this.$router.push("/login");
    },

  },
  watch: {
    cookieRemember() {
      const cookieExpireTime = new Date().getTime() + 24 * 60 * 60 * 1000;
      localStorage.setItem('rememberMeCookies', true);
      localStorage.setItem('cookieExpireTime', cookieExpireTime);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
.footer {
  background-color: $color-primary;
  height: 345px;
}
.footer--mobile {
  height: 100% !important;
}
.footer--color {
  color: $color-on-primary;
}
.menu--header {
  font-weight: $font-weight-bold;
  height: 40px;
}
.content-license {
  color: rgba(255, 255, 255, 0.7);
  // height: 27px;
}
.blank-menu {
  height: 1px;
}
.cookie-model {
  word-break: normal !important;
}
</style>
